module.exports = __webpack_public_path__ + "img/aa0b1f2.png";